import styled from "styled-components";

export default styled.figure`
  position: relative;
  z-index: -1; /* ensure the image is behind the content, particularly the shadow of the content wrapper */
  height: 350px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto 4vw;
  background: #929FAD;
  border-radius: 5px;
  
  .gatsby-image-wrapper {
    height: 100%;
  }
  
  @media (min-width: 768px) {
    height: 400px;
    margin-bottom: 2rem;
  }
  @media (min-width: 992px) {
    height: 600px;
    margin-bottom: -165px;
  }
  @media (min-width: 1200px) {
    height: 800px;
    width: 95vw;
  }
`;
